import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Wallet } from 'lucide-react';
import type { GuildTreasuryResponse } from '@/lib/api';

function formatTreasuryValue(value: string): string {
  return parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 8,
  });
}

interface GuildTreasuryCardProps {
  treasury: GuildTreasuryResponse | null;
  loading: boolean;
}

export function GuildTreasuryCard({ treasury, loading }: GuildTreasuryCardProps) {
  if (loading) {
    return (
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-sm flex items-center gap-2">
            <Wallet className="h-4 w-4" /> Treasury
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Loading...</p>
        </CardContent>
      </Card>
    );
  }

  if (!treasury) {
    return null;
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2">
          <Wallet className="h-4 w-4" /> Treasury
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex justify-between">
          <span className="text-sm text-muted-foreground">Balance</span>
          <span className="font-mono text-sm">{formatTreasuryValue(treasury.balance)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-muted-foreground">Lifetime Earned</span>
          <span className="font-mono text-sm">{formatTreasuryValue(treasury.lifetimeEarned)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm text-muted-foreground">Distribution Rule</span>
          <span className="text-sm capitalize">{treasury.distributionRule}</span>
        </div>
      </CardContent>
    </Card>
  );
}
